import dayjs from "dayjs";
import { DATATABLE_PAGING, DATE_TIME_MASK_POINT } from "@/utils/constants/common";
import { Currency } from "../currency";

export const handleInitialPagination = (initialPagination: any) => {
  return initialPagination
    ? {
        page: initialPagination.index,
        pageSize: initialPagination.size,
        status: "inside",
      }
    : {
        page: DATATABLE_PAGING.pageIndex,
        pageSize: DATATABLE_PAGING.pageSize,
        status: "inside",
      };
};

export const assignColumnDefaults = (cols: any) =>
  cols.map((column: any) => {
    const colDef = {
      ...column,
      flex: column.flex ?? 1,
      align: column.align ?? "left",
      headerAlign: column.headerAlign ?? "left",
    };

    if (column.type === "date") {
      colDef.renderCell = ({ row }: any) => dayjs(row[column.field]).format(DATE_TIME_MASK_POINT);
    }

    if (column.type === "currency") {
      colDef.renderCell = ({ row }: any) => <Currency amount={row[column.field]} />;
      colDef.type = "number";
    }

    return colDef;
  });
